import React, { useEffect, useState } from "react";
import {
  typeTicketOptions,
  companyOptions,
  formaPagoOptions,
  estadoOptions,
  accionOptions,
  accionDisconformidad,
  accionAceptar,
  accionNoAceptar,
  motivoOptions,
  motivorimacOptions,
  sunatStatusOptions,
  pagoStatusOptions,
  areaOptions,
  typeDocumentOptions,
  initDataUsuarioRimac,
  initDataProveedorRimac,
} from "../../utils/options";
import Jumpbotron from "../../components/common/Jumpbotron";
import { iconDownloadHead } from "../../components/common/icons";
import Input from "../../components/common/Input";
import Select from "../../components/common/Select";
import Button from "../../components/common/Button";
import deleteLogo from "../../assets/gl_delete-20.svg";
import editUserIcon from "../../assets/gl_edit_16.svg";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import InputPicker from "../../components/common/InputPicker";
import { Auth } from "aws-amplify";
import moment from "moment";
import "./styles.scss";
import { callService } from "../../amplify/callService";
import Modal from "../../components/common/Modal";
import { CONSTANTES } from "../../utils/Constantes";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../redux/actions/general";
import TableRimac from "../../components/common/Table/TableRimac";
import {
  iconDownloadUnavailable,
  iconDownload,
  iconFile,
  iconDeleteDropdown,
  iconEdit,
} from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import { getColorByStatusSunat, getColorByStatus, getColorByAccionCPE } from "../../utils/utils";
import { profileUsers, statusUsers } from "../../utils/options";
import InputFile from "../../components/common/InputFile";
import CardItem from "../../components/common/CardItem";
import Alert from "../../components/common/Alert";
import Pagination from "../../components/common/Pagination";
import Checkbox from "../../components/common/Checkbox";

const itemsPerPage = 10;

const ConsultaProveedores = (props, handleEdit = () => {}) => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });

  const [data, setData] = useState({});
  const [validacion, setValidacion] = useState({});
  const [dataconf, setDataconf] = useState(null);
  const [checkReporte, setCheckReporte] = useState(false);
  const [checkEmision, setCheckEmision] = useState(false);
  const [checkRecepcion, setCheckRecepcion] = useState(true);

  const [isInternalUser, setIsInternalUser] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [reporteData, setReporteData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [globalChecked, setGlobalCheked] = useState(false);
  const [tagBody, setTagBody] = useState("actions2");
  const [selectedRow, setSelectedRow] = useState(null);
  const [groups, setGroups] = useState(null);
  const [files, setFiles] = useState([]);
  const [arrAreas, setArrAreas] = useState([]);
  const [arrTipoDoc, setArrTipoDoc] = useState([]);
  const [emptyModal, setEmptyModal] = useState(false);
  const [username, setUsername] = useState("");
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });

  const handleChangeReporte = (event) => {
    console.log('============', event)
    setReporteData("");
    setCheckReporte(event.target.checked)
    //if(!event.target.checked) setEmail('');
  };
  const handleChangeEmision = (event) => {
    console.log('============', event);    
    setCheckEmision(event.target.checked);
    if(!event.target.checked){
      setCheckRecepcion(true);
    }
    //if(!event.target.checked) setEmail('');
  };
  const handleChangeRecepcion = (event) => {
    console.log('============', event)
    setCheckRecepcion(event.target.checked);
    if(!event.target.checked){
      setCheckEmision(true);
    }
    //if(!event.target.checked) setEmail('');
  };

  const getDataFromCurrentUser = async () => {
    const currentUser = await Auth.currentAuthenticatedUser();
    console.log("currentUser", currentUser);
    const typeUser = currentUser?.attributes["custom:type_user"];
    const rucUser = currentUser?.attributes["custom:ruc"];
    setUsername(currentUser?.username);
    return { typeUser, rucUser };
  };

  const initialSetup = async () => {
    const currentUser = await Auth.currentAuthenticatedUser();
    const roleUser =
      currentUser?.signInUserSession.accessToken.payload["cognito:groups"];
    setGroups(roleUser);
    setTableData([]);
    setData({});
    const { typeUser, rucUser } = await getDataFromCurrentUser();
  };

  useEffect(() => {
    initialSetup();
    getTipoDoc();
  }, []);

  useEffect(() => {
    //if (tableData && tableData.length > 0) {
    if(currentPage){
      console.log(currentPage);
      handleSearchEndpoint();
    }
  }, [currentPage]);

  const getTipoDoc = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPDOC'));
      if (response.ok && response.data && response.data.payload) {
        let tipdoc = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoDoc(tipdoc);
      }
    } catch (ex) {
      console.log("Error al obtener tipdoc", ex);
    }
  };
  const handleChangeCheckBox = (index) => {
    let newList = [...tableData];
    newList[index].checked = !newList[index].checked;
    setTableData(newList);
  };

  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);

  const handleShowModal = (row, tag) => {
      if (!showModal) setShowModal(true);
      setTagBody(tag);
      if (tag === "evaluar"){
        setSelectedRow(row);
        /*let jsComentario = JSON.parse(row.comentario);        
        setData({ ...data, 
                accion: (accionOptions[row.estado]||[]).find(el=>el.value==row.accion)||{}, 
                motivo:  motivoOptions.find(el=>el.value==jsComentario.codigo)||{}, 
                mensaje: jsComentario.mensaje,
                motivorimac:  motivorimacOptions.find(el=>el.value==jsComentario.codigoRimac)||{}});*/
      }      
    };
  const handleCloseModal = (value) => {
    setSelectedRow(null);
    setShowModal(value);
  };

  const handleGuardarModal = async (value) => {
    if(!validarDataConformidad())
      return true;
    let payload = {
      idProveedor: selectedRow.idProveedor,      
      idpEstadoRegistro: data.idpEstadoRegistroAc ? data.idpEstadoRegistroAc.value: "",
      comentario: data.comentario ? data.comentario: ""           
    };
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.actualizarFichaProveedorGestion,
      fetchObj
    );    
    dispatch(hideLoading());
    if (response.ok) {
      //let { totalPages } = response.data;
      //setPaginationData({ ...paginationData, totalPages: totalPages });

      /*let arrData =
        response &&
        response.data &&
        response.data.rows; 
      setTableData(arrData);*/
      setShowModal(false);
      handleSearchEndpoint();
    } else {
      console.log("Error fetching data => ", response.message);
      //setTableData([]);
      setEmptyModal(true);
    }

  };


  const handleChange = (name, value) => {
    value = value.toUpperCase ? value.toUpperCase() : value;
    console.log("VALUEE:", value);    
    setData({ ...data, [name]: value });
    setValidacion({...validacion, [name]: false });
  };

  const handleChangeModal = (name, value) => {
    value = value.value;
    value = value.toUpperCase ? value.toUpperCase() : value;
    console.log("VALUEE:", value);
    setData({ ...data, [name]: value });
  };

  const validarDataConformidad = () => {
   let resp= true;
   let estado, comentario;
    if (!data.idpEstadoRegistroAc){
      estado= true;
      resp = false;
    }
    if (!data.comentario){
        comentario= true;
        resp = false;
    }    
   
    setValidacion({...validacion, idpEstadoRegistroAc:estado, comentario:comentario});
    return resp;
  };

  const handleDate = (name, objDate) => {
    const newDate = objDate.hasErrorFormat ? new Date() : objDate.value;
    setData({ ...data, [name]: newDate });
  };

  const handleClean = async () => {
    await initialSetup();
  };

  const handleSearchEndpoint = async () => {
    console.log( moment(data.fecInicio).format("YYYY-MM-DD"))   
    let payload = {
      page: currentPage,
      pageSize: itemsPerPage,
      nombreRazonSocial: data.nombreRazonSocial ? data.nombreRazonSocial : "",      
      idpEstadoRegistro: data.idpEstadoRegistro ?  data.idpEstadoRegistro.value : "",
      fecInicio:
        data.fecInicio?
        moment(data.fecInicio).format("YYYY-MM-DD"):"",
      fecFin:
        data.fecFin?
        moment(data.fecFin).format("YYYY-MM-DD"):"",      
      idpTipoDocumento: data.idpTipoDocumento ? data.idpTipoDocumento.value : "",
      numDocumento: data.numDocumento ? data.numDocumento : ""     
    };
    setReporteData("");
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.consultarFichaProveedor,
      fetchObj
    );    
    dispatch(hideLoading());
    if (response.ok && response.data) {
      let { totalPages } = response.data;
      setPaginationData({ ...paginationData, totalPages: totalPages });

      let arrData =
        response &&
        response.data &&
        response.data.rows; /*&&
        response.data.rows.map((item) => {
          let obj = {
            broadcast:  (item.fecemision && item.fecemision.split("T")[0]) || '',
            docType: item.codcpe || '',
            docNumber: item.numserie + '-' + String(item.numcpe).padStart('8','0') || '',
            clientDoc: item.numruc ||'',            
            currency: item.currency ||'',
            amount: item.amount  || 0.00,
            taxes: item.taxes || 0.00,
            total: item.total || 0.00,
            reception: (item.dateTimeCreationStr &&item.dateTimeCreationStr.split(" ")[0]) || '',
            filesAdic: item && item.filesSupport ? item.filesSupport : [],
            checked: false,
            descPayment: item.descripcionPagoEqui || "",
            replaceInvoice: item.facturaReemplazo || "",
            dateTimeCreation: item.dateTimeCreation || 0,
            area: item.area || "",
            sistemaOrigen : item.sistemaOrigen || '',
            description : item.description || '',
            amountDetraction : item.amountDetraction || '',
            otherCharge : item.otherCharge || '',
            percentageDetraction : item.percentageDetraction || '',
            serviceCode : item.serviceCode || '',
            sunatMessage : item.sunatMessage
          };
          return obj;
        });*/
      setTableData(arrData);
    } else {
      console.log("Error fetching data => ", response.message);
      setTableData([]);
      setEmptyModal(true);
    }
  };
 

  const handlePressEnter = (e) => {
    if (e.key === "Enter") {
      setCurrentPage(new Number(1));
    }
  };

  const bodyModal = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">Aviso</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-05 margin-bottom-10">
            No se encontro{" "}
            <span className="title-05 color-red">
              <strong>documentos</strong>
            </span>
          </h4>
        </div>
      </div>
    );
  };

  const bodyModalComentario = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">
           <span className="title-05 color-red">
              <b>Evaluar </b>
            </span>        
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <div className="margin-bottom-16 margin-top-48">
            <div className="d-justify-space-between d-flex-column-m w100">              
                <Select
                  label="Estado"
                  selected={data?.idpEstadoRegistroAc}
                  onChange={(newValue) => handleChange("idpEstadoRegistroAc", newValue)}
                  items={estadoOptions}
                  hasError = {validacion.idpEstadoRegistroAc && '*'}
                />              
            </div>            
            {<div className="d-justify-space-between d-flex-column-m w100">              
                  <Input
                    label={"Comentario"}
                    name="comentario"
                    type="text"
                    maxLength="500"
                    minLength="5"
                    value={data?.comentario}
                    onChange={(newValue) =>
                      handleChange("comentario", newValue)
                    }                    
                    hasError = {validacion.comentario && '*'}
                  />              
                </div>            
            }                   
          </div>         
        </div>
      </div>
    );
  };

  const handleGlobalChecked = () => {
    const newGlobal = !globalChecked;
    setGlobalCheked(newGlobal);
    let lista = tableData.map((item) => {
      return { ...item, ["checked"]: newGlobal };
    });
    setTableData(lista);
  };

  let TABLE_COLUMNS = [    
    { ResOrder: 1, Title: "Tipo Documento", RowName: "idpTipoDocumento" },
    { ResOrder: 2, Title: "Número Documento", RowName: "numDocumento" },
    { ResOrder: 3, Title: "Razón Social", RowName: "nombreRazonSocial" },
    {
      ResOrder: 4,
      Title: "Estado Registro",
      Special: (elem) => (
        <Chip          
          label={estadoOptions.find(el=>el.value==elem.idpEstadoRegistro).text}
          color={getColorByStatus(elem.idpEstadoRegistro)}
        />        
      ),
    },
    { ResOrder: 5, Title: "Fec Registro",
      Special: (elem) => {
        return moment(elem.fecCreacion).format("YYYY-MM-DD")
      }  
    },
    { ResOrder: 6, Title: "Evaluar", 
      Special: (elem) => {      
      return (
         <Button
         className="padding-5"
         size="small"
         iconLeft={
           <img
             src={editUserIcon}
             alt="edit user logo"
             height={15}
             className="margin-right-8"
           />
         }
         onClick={() => handleShowModal(elem, "evaluar")}
       >
         
       </Button>       
      )
    }
    },
    { ResOrder: 7, Title: "Comentario", RowName: "comentario" }
  ];
 

  return (
    <div className="documents d-justify-center padding-bottom-16">
      {/* <> */}
      <Jumpbotron
        paths={["Consulta", "Proveedores"]}
        titleBlack="Consultas de"
        titleRed="Proveedores"
        subTitle="Aqui puedes revisar y visualizar las Fichas de Proveedores"
      />
      <div className="content-grilla" style={{width:"80%"}}>
        <h4 className="title-06 margin-bottom-16 margin-top-48">
          Inicia tu búsqueda
        </h4>
        <div
          // onSubmit={handleSearch}
          className="consulta_prov_criteria w100 margin-bottom-16"
        >          
          
          <div className="d-justify-space-between d-flex-column-m w100">            
            <div className="consulta_prov_criteria_dateInit">
              <InputPicker
                label="Fecha Inicio"
                // value={data?.initDate}
                value={data?.fecInicio ? data?.fecInicio :  new Date()}
                onChange={(objDate) => handleDate("fecInicio", objDate)}
                maxDate={data?.fecFin}
                onkeydown={handlePressEnter}
              />
            </div>
            <div className="consulta_prov_criteria_dateEnd">
              <InputPicker
                label="Fecha Fin"
                // value={data?.endDate}
                //disabled={!checkEmision?"disabled":""}
                value={data?.fecFin ? data?.fecFin : new Date()}
                onChange={(objDate) => handleDate("fecFin", objDate)}
                onkeydown={handlePressEnter}
              />
            </div>
            <div className="consulta_prov_criteria_company">
              <Select
                label="Estado"
                selected={data?.idpEstadoRegistro}
                onChange={(newValue) => handleChange("idpEstadoRegistro", newValue)}
                items={estadoOptions}
              />
            </div>             
          </div>          
          <div className="d-justify-space-between d-flex-column-m w100">
              <div className="consulta_prov_criteria_doc">
                <InputWithDropdown
                  selectProps={{
                    label: "Tipo Doc",
                    selected:data?.idpTipoDocumento,
                    onChange: (newValue) =>
                      handleChange("idpTipoDocumento", newValue),
                    items: arrTipoDoc
                  }}
                  inputProps={{
                    label: "Número Documento",
                    name: "numDocumento",
                    maxLength: "15",
                    value: data?.numDocumento,
                    customRegex: /^[a-zA-Z0-9]*$/,
                    onChange: (newValue) =>
                      handleChange("numDocumento", newValue)
                  }}
                />
              </div> 
              <div className="consulta_prov_criteria_company" >
              <Input
                label="Nombre Proveedor"
                name="nombreRazonSocial"
                type="text"
                maxLength="500"
                value={data?.nombreRazonSocial}
                onChange={(newValue) =>
                  handleChange("nombreRazonSocial", newValue)
                }
                onkeydown={handlePressEnter}
              />
            </div>
          </div>        
        
          <div className="consulta_prov_criteria_btns d-flex-end margin-bottom-16">
            <div className="consulta_prov_btnSearch">
              <Button
                // type="submit"
                primary
                size="large"
                onClick={()=>{
                  setCurrentPage(new Number(1));
                }}
              >
                BUSCAR
              </Button>
            </div>
            <div className="consulta_prov_btnClean">
              <Button
                size="medium"
                iconLeft={<img src={deleteLogo} alt="delete logo" />}
                onClick={handleClean}
              >
                LIMPIAR
              </Button>
            </div>
            
          </div>
        </div>

        {showAlert.show && (
          <Alert
            title={showAlert.title}
            message={showAlert.message}
            type={showAlert.type}
            hasBg={true}
            position="top-right"
            handleClose={() => resetAlert()}
          />
        )}        
        <div className="consulta_prov_table w100">
          <div className="consulta_prov_table_head">
            <h4 className="title-05 margin-top-16 margin-bottom-16">
            Lista de Fichas de Proveedor creadas
            </h4>            
          </div>
          <div className="consulta_prov_table_wrapp">
            <TableRimac
              TC_setGlobalCheked={handleGlobalChecked}
              TC_globalCheked={globalChecked}
              TC_tableColumns={TABLE_COLUMNS}
              TC_list={tableData}
              TC_handleChangeCheckBox={handleChangeCheckBox}
              TC_hasIndex={false}
              TC_handleOrderData={(newList) => setTableData(newList)}
            />
            {emptyModal && (
              <Modal
                className="rd--modal-info-files"
                onToggle={(value) => setEmptyModal(false)}
                visible={emptyModal}
                width={672}
                fullScreenMobile
                redHoverClosed
                onLabelClosed
                max12Padding
                footer={
                  <Button primary onClick={() => setEmptyModal(false)}>
                    Cerrar
                  </Button>
                }
              >
                {bodyModal()}
              </Modal>
            )}
            {showModal && (
          <Modal
            className="rd--modal-info-files"
            onToggle={(value) => handleCloseModal(value)}
            visible={showModal}
            width={672}
            fullScreenMobile
            redHoverClosed
            onLabelClosed
            max12Padding
            footer={
              <>
                <div className="consulta_prov_criteria_serie" style={{width: '47%'}}>
                <Button primary onClick={() => handleCloseModal(false)}>
                  {"CANCELAR"}
                </Button>
                </div>
                <div className="consulta_prov_criteria_serie" style={{width: '47%'}}>
                <Button primary onClick={() => handleGuardarModal(false)}>
                {"OK"}
                </Button>
                </div>
              </>
            }
          >
            {tagBody === "evaluar"
              ? bodyModalComentario()
              : ""}
          </Modal>
        )}
          </div>
          {tableData && tableData.length > 0 && (
            <div className="consulta_prov_table_pagination">
              <Pagination
                current={currentPage}
                pages={paginationData.totalPages}
                onNewPage={(newPage) => setCurrentPage(newPage)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConsultaProveedores;